import script from "./TheHome.vue?vue&type=script&setup=true&lang=js"
export * from "./TheHome.vue?vue&type=script&setup=true&lang=js"

import "./TheHome.vue?vue&type=style&index=0&id=89e98624&lang=scss"

const __exports__ = script;

export default __exports__